import React, { BaseSyntheticEvent, useEffect, useState } from "react";

const UrlParam = (props: any) => {
    let [inputList, setInputList] = useState(props.inputList);
    let [isAddUrlParam, setAddUrlParam] = useState(props.isAddUrlParam);

    useEffect(() => {
        setInputList(props.inputList);
        if (props.inputList[0].urlType) {
            setAddUrlParam(false);
        }
    }, [props.inputList]);

    /**
     * handles changes in the input of Key and value field of Url Param
     * @param {BaseSyntheticEvent} e
     * @param {number} index
     * @memberof UrlParam
     */
    const handleInputChange = (e: BaseSyntheticEvent, index: number) => {
        const { name, value } = e.target;
        const list: any = [...inputList];

        list[index][name] = value;
        setInputList(list);
        props.setInputList(list, isAddUrlParam);
        setInputList(props.inputList);
    };

    /**
     * Removes the key and value field of url param
     * @param {number} index
     * @memberof UrlParam
     */
    const handleRemoveClick = (index: number) => {
        let list = [...inputList];
        list = list.filter((fieldName: string, fieldIndex: number) => fieldIndex !== index);
        setInputList(list);
        if (list.length === 0) {
            setAddUrlParam(true);
            setInputList([{ urlType: "", urlParam: "" }]);
        }
    };

    /**
     * Adds the key and value field of url param
     * @memberof UrlParam
     */
    const handleAddClick = () => {
        setInputList([...inputList, { urlType: "", urlParam: "" }]);
    };

    return (
        <div className="slds-form-element">
            {inputList.map((field: any, index: number) => {
                const selectedField: { name: string, placeholder: string, role: string, value: string }[] = [
                    { name: 'urlType', placeholder: "Add Key", role: 'urlType', value: field.urlType },
                    { name: 'urlParam', placeholder: "Add Value", role: 'urlParam', value: field.urlParam },
                ];
                return (
                    <div className="slds-form-element">
                        {isAddUrlParam ?
                            (<button
                                className="slds-button slds-button_neutral"
                                onClick={(e: any) => setAddUrlParam(false)}
                            >
                                Add URL Param
                            </button>) : (
                                <div className=" slds-form-element" >
                                    {index == 0 ? <label className="slds-form-element__label">Url Param</label> : ''}
                                    <form className="slds-form--compound--horizontal">
                                        <div className="slds-grid slds-grid_vertical">
                                            <div className="slds-form-element slds-size_2-of-3 slds-float_left slds-max-small-size_1-of-1">
                                                {selectedField && selectedField.map((data: { role: string, name: string, placeholder: string, value: string }, key) => {
                                                    return (
                                                        <div className="slds-form-element">
                                                            <input
                                                                type="text"
                                                                id=""
                                                                placeholder={data.placeholder}
                                                                name={data.name}
                                                                value={data.value}
                                                                role={data.role}
                                                                onChange={e => handleInputChange(e, index)}
                                                                className="slds-input" />
                                                        </div>)
                                                })
                                                }
                                            </div>
                                            <div className="slds-button-group  slds-size_1-of-3 slds-float_right" role="group" >
                                                {
                                                    <button
                                                        className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-top_none"
                                                        role="add-select"
                                                        onClick={handleAddClick}>
                                                        <i className="cq-icon-add cq-1x"></i>
                                                    </button>}
                                                {
                                                    <button
                                                        className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-top_none"
                                                        role="delete-select"
                                                        onClick={() => { handleRemoveClick(index) }}>
                                                        <i className="cq-icon-delete cq-1x"></i>
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            )}
                    </div>
                );
            })}
        </div>
    );
}
export default UrlParam;